Object.defineProperty(exports, "__esModule", { value: true });
var Sequence_1 = require("./Sequence");
var Flatten = /** @class */ (function () {
    function Flatten() {
    }
    /**
     * Returns a single flat sequence of all the items from all sequences or iterables.
     *
     * @returns {Sequence<T>}
     */
    Flatten.prototype.flatten = function () {
        return this.flatMap(function (it) {
            if (Sequence_1.isSequence(it)) {
                return it;
            }
            else {
                return Sequence_1.asSequence(it);
            }
        });
    };
    return Flatten;
}());
exports.Flatten = Flatten;
//# sourceMappingURL=flatten.js.map